import 'extensions/invoice-lookup';
import 'extensions/rma/components/x-rma-invoice-lookup-form';
import 'extensions/ui-components/g-modal';
import {PageManager} from 'genesis-packages/core';
import './ORDH.scss';

export default class ORDH extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

};
